import { useState } from 'react';
import { navLinks, noticeText } from '@/mocks/homeData';

export default function TopBar() {
  const [open, setOpen] = useState(false);

  return (
    <header id="top" className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="w-full overflow-hidden border-b border-background-200/70 bg-foreground-900 py-1.5">
        <div className="flex w-max animate-marquee items-center gap-16 whitespace-nowrap px-4 text-xs text-background-100/90">
          <span>{noticeText}</span>
          <span>{noticeText}</span>
        </div>
      </div>

      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-cake-2-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">91吃瓜</span>
            <span className="mt-0.5 text-[10px] font-label tracking-widest text-foreground-400">入口 · 下载 · 地址</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#address"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-login-circle-line" />
            一键进站
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="flex flex-col gap-1 border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setOpen(false)}
              className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#address"
            onClick={() => setOpen(false)}
            className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
          >
            <i className="ri-login-circle-line" />
            一键进站
          </a>
        </nav>
      )}
    </header>
  );
}